"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryData = void 0;
const utils_1 = require("../../utils");
const lodash_1 = __importDefault(require("lodash"));
var QueryData;
(function (QueryData) {
    function queryParamsForPin(data, pinId) {
        const dict = {};
        lodash_1.default.forEach(data, (value, key) => {
            const [kPinId, param] = key.split('-');
            if (kPinId === pinId) {
                dict[param] = value;
            }
        });
        return dict;
    }
    QueryData.queryParamsForPin = queryParamsForPin;
    function valueForPin(data, pinId, paramName) {
        return lodash_1.default.get(data, `${pinId}-${paramName}`);
    }
    QueryData.valueForPin = valueForPin;
    function fromQueryParams(params, pinId) {
        return lodash_1.default.mapKeys(params, (v, k) => `${pinId}-${k}`);
    }
    QueryData.fromQueryParams = fromQueryParams;
    function toQueryString(data) {
        const pairs = lodash_1.default.toPairs(data);
        const encoded = pairs.map(([key, value]) => [encodeURIComponent(key), encodeURIComponent(value)].join('='));
        return encoded.join('&');
    }
    QueryData.toQueryString = toQueryString;
    function fromQueryString(qs) {
        if (!qs)
            return {};
        const cleaned = lodash_1.default.startsWith(qs, '#') ? qs.substr(1) : qs;
        const splitted = lodash_1.default.split(cleaned, '&');
        const encodedPairs = lodash_1.default.map(splitted, (s) => s.split('='));
        const pairs = (0, utils_1.compactMap)(encodedPairs, ([key, value]) => {
            if (lodash_1.default.isEmpty(key)) {
                return undefined;
            }
            return [decodeURIComponent(key), decodeURIComponent(value)];
        });
        return lodash_1.default.fromPairs(pairs);
    }
    QueryData.fromQueryString = fromQueryString;
})(QueryData || (exports.QueryData = QueryData = {}));
//# sourceMappingURL=QueryData.js.map